import { Link, useLocation } from "react-router-dom";
import { useCart } from "@/App";
import { Home, Search, ShoppingCart, User } from "lucide-react";

export default function MobileNav() {
  const location = useLocation();
  const { itemCount } = useCart();

  const navItems = [
    { path: "/", icon: Home, label: "Inicio" },
    { path: "/tienda", icon: Search, label: "Tienda" },
    { path: "/carrito", icon: ShoppingCart, label: "Carrito", badge: itemCount },
    { path: "/mi-cuenta", icon: User, label: "Cuenta" },
  ];

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-border z-40 safe-area-pb" data-testid="mobile-nav">
      <div className="flex items-center justify-around h-16">
        {navItems.map(({ path, icon: Icon, label, badge }) => (
          <Link
            key={path}
            to={path}
            className={`flex flex-col items-center justify-center flex-1 h-full relative ${
              isActive(path) ? "text-primary" : "text-muted-foreground"
            }`}
            data-testid={`mobile-nav-${label.toLowerCase()}`}
          >
            <div className="relative">
              <Icon className="w-6 h-6" />
              {badge > 0 && (
                <span className="absolute -top-2 -right-2 bg-accent text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold">
                  {badge}
                </span>
              )}
            </div>
            <span className="text-xs mt-1">{label}</span>
            {isActive(path) && (
              <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-8 h-1 bg-primary rounded-t-full"></span>
            )}
          </Link>
        ))}
      </div>
    </nav>
  );
}
